import { render } from "./ModalQuizProfile.vue?vue&type=template&id=6ffecc7e"
import script from "./ModalQuizProfile.vue?vue&type=script&lang=js"
export * from "./ModalQuizProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__